<template>
    <div class="map-container" id="map-starfield" ref="mapCantainer">
        <div class="map__floor-container">
            <ul class="map__floor-list" role="tablist">
                <li v-for="(item, index) in mapList" :key="index" :class="index === pointIndex ? 'active' : ''">
                    <p role="tab" aria-label="${item.floorNm}" @click="doPointImgUrl(item.fileUrl, index)">{{ item.floorNm }}</p>
                </li>
            </ul>
        </div>
        <div class="map__zoom-container">
            <button class="map__zoom__btn-in" type="button" aria-label="지도확대 버튼" @click="zoomIn">지도 확대</button>
            <button class="map__zoom__btn-out" type="button" aria-label="지도축소 버튼" @click="zoomOut">지도 축소</button>
        </div>
        <div class="map__img-container">
            <img :src="imgUrl" alt="스타필드 마켓 지도" ref="panzoomImg" />
        </div>
    </div>
</template>

<script setup>
    import { onMounted, ref, toRefs, nextTick } from 'vue';
    import panzoom from 'panzoom';
    import { useRootStore } from '@/stores/modules';

    const rootStore = useRootStore();
    const { selectedBranchId } = toRefs(rootStore);

    const panzoomInstance = ref(null);
    const pointIndex = ref(0);
    const mapList = ref([]);
    const mapCantainer = ref(null);
    const panzoomImg = ref(null);

    const imgUrl = 'https://www.starfieldmarket.com/resource/images/map/map_b1.png';

    const getFloorList = async () => {
        const url = `/map/list?branchId=${selectedBranchId.value}&gubun=map`;
        const res = await rootStore.getStarFieldInfo(url);

        if (res?.status === 200) {
            const list = res.data.mapList;
            const point = list.length - 1;

            // 가장 낮은층 표시
            doPointImgUrl(list[0]?.fileUrl, point);
            mapList.value = list.reverse();

            // 전달되는 인수의 초기화
            localStorage.setItem('sendData', null);
        }
    };
    // 층별 지도표시
    const doPointImgUrl = (fileUrl, index) => {
        if (panzoomInstance.value !== null) {
            panzoomInstance.value.pause();
        }

        panzoomImg.value.src = fileUrl;
        pointIndex.value = index;
    };
    // 줌 인
    const zoomIn = () => {
        const container = mapCantainer.value.getBoundingClientRect();
        const centerX = container.width / 2;
        const centerY = container.height / 2;
        panzoomInstance.value.smoothZoom(centerX, centerY, 1.25);
    };
    // 줌 아웃
    const zoomOut = () => {
        const container = mapCantainer.value.getBoundingClientRect();
        const centerX = container.width / 2;
        const centerY = container.height / 2;
        panzoomInstance.value.smoothZoom(centerX, centerY, 0.8);
    };

    onMounted(async () => {
        // 층정보
        getFloorList();

        await nextTick();

        const imageElement = panzoomImg.value; // 이미지 요소 참조
        if (imageElement) {
            imageElement.addEventListener('load', () => {
                const imageHeight = imageElement.clientHeight === 0 ? imageElement.height : imageElement.clientHeight;
                const initialZoom = (window.innerHeight - 60) / imageHeight;

                const initialX = mapCantainer.value.clientWidth / 2 - (imageElement.width * initialZoom) / 2;

                panzoomInstance.value = panzoom(imageElement, {
                    maxZoom: 2,
                    minZoom: 0.2,
                    bounds: true,
                    boundsPadding: 0.1,
                    initialX: initialX,
                    initialY: 0,
                    initialZoom: initialZoom,
                    zoomDoubleClickSpeed: 1,
                });

                if (window.innerHeight > window.innerWidth) {
                    imageElement.parentElement.style.transformOrigin = '-60% 0';
                }
            });
        }
    });
</script>

<script>
    export default {
        name: 'MapContainer',
    };
</script>
